{ connect } = require 'react-redux'
FooterComponent = require '../components/Footer'

mapStateToProps = (state) ->
	isLoggedIn: state.auth.isAuthenticated

Footer = connect(mapStateToProps)(FooterComponent)

module.exports = Footer



// WEBPACK FOOTER //
// ./~/cjsx-loader!./frontend/olos/js/containers/Footer.cjsx